export default "/images/eae125b10802e4eb857ed3d48d8caa92.avif";